import { useState } from "react";
import { toast } from "sonner";
import { Link2, Unlink, Search } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { fmtMoney, fmtDate } from "./apUtils";

export function ApRampMatch({ inv, onChange }) {
  const [cands, setCands] = useState(null);
  const [loading, setLoading] = useState(false);
  const find = async () => {
    setLoading(true);
    try { setCands((await api.get(`/ap/invoices/${inv.id}/ramp-candidates`)).data); }
    catch (err) { toast.error("Ramp lookup failed", { description: formatApiErrorDetail(err.response?.data?.detail) }); }
    finally { setLoading(false); }
  };
  const link = async (bill_id) => {
    try { onChange((await api.post(`/ap/invoices/${inv.id}/ramp-match`, { bill_id })).data); setCands(null); toast.success(bill_id ? "Linked to Ramp bill" : "Unlinked"); }
    catch (err) { toast.error("Could not update", { description: formatApiErrorDetail(err.response?.data?.detail) }); }
  };
  if (inv.ramp_bill_id) {
    return (
      <div className="flex items-center justify-between text-sm border border-brand-border rounded-md px-3 py-2" data-testid="ap-ramp-linked">
        <span className="text-brand-ink">Linked to Ramp bill <span className="font-mono text-xs">{inv.ramp_bill_id.slice(0, 10)}…</span></span>
        <button onClick={() => link(null)} data-testid="ap-ramp-unlink" className="text-brand-muted hover:text-rose-700 transition-colors"><Unlink className="h-4 w-4" /></button>
      </div>
    );
  }
  return (
    <div className="space-y-2">
      <button onClick={find} disabled={loading} data-testid="ap-ramp-find"
        className="inline-flex items-center gap-1.5 text-sm border border-brand-border rounded-full px-3 py-1.5 text-brand-ink hover:bg-brand-hover transition-colors disabled:opacity-50">
        <Search className="h-3.5 w-3.5" /> {loading ? "Searching Ramp…" : "Find matching Ramp bill"}
      </button>
      {cands && !cands.length && <p className="text-xs text-brand-muted" data-testid="ap-ramp-none">No matching bills in Ramp.</p>}
      {cands?.map((b) => (
        <div key={b.id} className="flex items-center justify-between gap-2 text-xs border border-brand-border rounded-md px-3 py-2" data-testid={`ap-ramp-cand-${b.id}`}>
          <span className="text-brand-ink">{b.vendor} · {b.invoice_number || "no #"} · {fmtMoney(b.amount)} · due {fmtDate(b.due_date)} · {b.status}</span>
          <button onClick={() => link(b.id)} data-testid={`ap-ramp-link-${b.id}`} className="shrink-0 inline-flex items-center gap-1 text-brand-primary hover:underline"><Link2 className="h-3.5 w-3.5" /> Link</button>
        </div>
      ))}
    </div>
  );
}
